"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _Section = _interopRequireDefault(require("../Section/Section"));
var _ContributionBlock = _interopRequireDefault(require("./ContributionBlock"));
var _Threshold = _interopRequireDefault(require("./Threshold.style"));
var _ThresholdMember = _interopRequireDefault(require("./ThresholdMember"));
var _card = require("../../card");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Thresholds = function Thresholds(_ref) {
  var ruleIndex = _ref.ruleIndex,
    labels = _ref.labels,
    builderData = _ref.builderData,
    thresholds = _ref.thresholds,
    errors = _ref.errors,
    formulaOperators = _ref.formulaOperators,
    actions = _ref.actions,
    disabled = _ref.disabled;
  if (R.isEmpty(builderData) && R.isEmpty(thresholds)) {
    return /*#__PURE__*/_react["default"].createElement(_Section["default"], {
      name: "".concat((0, _utils.toUpper)(labels.PENSION_THRESHOLD_LABEL), " 1"),
      index: 1,
      labels: labels,
      className: "formula-empty-placeholder"
    }, /*#__PURE__*/_react["default"].createElement(_card.BuildArea, {
      className: "formula-placeholder"
    }, labels.PENSION_THRESHOLD_PLACEHOLDER));
  }
  return thresholds.map(function (item, index) {
    var thresholdActions = {
      onAdd: function onAdd() {
        return actions.thresholdChange('add', {
          ruleIndex: ruleIndex,
          thresholdIndex: index
        });
      },
      onDuplicate: function onDuplicate() {
        return actions.thresholdChange('duplicate', {
          ruleIndex: ruleIndex,
          thresholdIndex: index,
          sourceThreshold: item
        });
      }
    };
    if (thresholds.length > 1) {
      thresholdActions.onDelete = function () {
        return actions.thresholdChange('delete', {
          ruleIndex: ruleIndex,
          thresholdIndex: index
        });
      };
    }
    return /*#__PURE__*/_react["default"].createElement(_Section["default"], _extends({
      disabled: disabled,
      name: "".concat((0, _utils.toUpper)(labels.PENSION_THRESHOLD_LABEL), " ").concat(index + 1),
      key: item.name,
      index: index + 1
    }, thresholdActions, {
      labels: labels,
      className: R.isEmpty(builderData) ? 'formula-empty-placeholder' : ''
    }), R.isEmpty(builderData) ? /*#__PURE__*/_react["default"].createElement(_card.BuildArea, {
      className: "formula-placeholder"
    }, labels.PENSION_THRESHOLD_PLACEHOLDER) : /*#__PURE__*/_react["default"].createElement(_Threshold["default"], null, R.prop('thresholdRows', item) && item.thresholdRows.map(function (thresholdRowData, thresholdRowIndex) {
      return /*#__PURE__*/_react["default"].createElement(_ThresholdMember["default"], {
        actions: actions,
        ruleIndex: ruleIndex,
        disabled: disabled,
        elementKey: thresholdRowData.key,
        key: thresholdRowData.field,
        errors: R.prop(index, errors),
        thresholdIndex: index,
        blockType: thresholdRowIndex === 0 ? 'if' : 'and',
        thresholdRowIndex: thresholdRowIndex,
        labels: labels,
        thresholds: item,
        blockData: R.path(['thresholdRows', thresholdRowIndex], item),
        formulaOperators: formulaOperators
      });
    }), /*#__PURE__*/_react["default"].createElement(_ContributionBlock["default"], {
      data: item,
      labels: labels,
      errors: errors,
      disabled: disabled,
      ruleIndex: ruleIndex,
      formulaOperators: formulaOperators,
      thresholdIndex: index,
      member: item,
      key: item.key,
      keysPath: [index],
      actions: actions
    })));
  });
};
Thresholds.defaultProps = {
  errors: {},
  disabled: false
};
Thresholds.propTypes = {
  disabled: _propTypes["default"].bool,
  ruleIndex: _propTypes["default"].number.isRequired,
  errors: _propTypes["default"].shape({}),
  formulaOperators: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    displayName: _propTypes["default"].string,
    name: _propTypes["default"].string
  })).isRequired,
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  builderData: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    type: _propTypes["default"].string,
    displayName: _propTypes["default"].string
  })).isRequired,
  actions: _propTypes["default"].objectOf(_propTypes["default"].func).isRequired,
  formulaOtherProps: _propTypes["default"].shape({}),
  /* The root thresholds for each threshold */
  thresholds: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
};
Thresholds.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Thresholds",
  "props": {
    "errors": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "ruleIndex": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "formulaOperators": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "displayName": {
              "name": "string",
              "required": false
            },
            "name": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": true
    },
    "labels": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": true
    },
    "builderData": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "value": {
              "name": "string",
              "required": false
            },
            "type": {
              "name": "string",
              "required": false
            },
            "displayName": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": true
    },
    "actions": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "func"
        }
      },
      "required": true
    },
    "formulaOtherProps": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "thresholds": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": true
    }
  }
};
var _default = Thresholds;
exports["default"] = _default;